module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic_content"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "topic_top_right"
  }, [_c('label', {
    staticClass: "topic_top_text"
  }, [_vm._v("第" + _vm._s(_vm.title_nums) + "题")])]), _vm._v(" "), _c('div', {
    staticClass: "topic_top_left",
    staticStyle: {
      "background-size": "250px 100px"
    }
  }, [_c('label', {
    staticClass: "level_text"
  }, [_vm._v(_vm._s(_vm.gold_total_nums))])])]), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_c('div', {
    staticClass: "topic_left"
  }), _vm._v(" "), _c('div', {
    staticClass: "topic_center"
  }, [_c('div', [_c('label', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.topic_info.topic_title))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.choice_button(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[0]))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.choice_button(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[1]))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.choice_button(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[2]))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.choice_button(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[3]))])])]), _vm._v(" "), _c('div', {
    staticClass: "topic_right"
  }, [_c('div', {
    staticClass: "hint_button"
  }, [_c('input', {
    staticClass: "hit_button",
    attrs: {
      "type": "button",
      "value": "提示"
    },
    on: {
      "click": _vm.hint_button
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "mask_background"
  }, [_c('div', {
    staticClass: "mask_info_background"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60%"
    }
  }, [_c('div', {
    staticClass: "mask_info_text"
  }, [_c('label', [_vm._v(_vm._s(_vm.answer_info))])]), _vm._v(" "), _c('div', {
    staticClass: "mask_info_text"
  }, [_c('label', [_vm._v(_vm._s(_vm.add_gold))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('input', {
    staticClass: "mask_button",
    attrs: {
      "type": "button",
      "value": "下一关"
    },
    on: {
      "click": _vm.next_button
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26defe58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 73
// module chunks = 2